import styled, { css } from 'styled-components';
import Ava24 from 'dc/Ava24';
import Ava36 from 'dc/Ava36';
import { Typ10, Typ11, Typ21 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import Lab110 from 'dc/Lab110';

type NameWrapper = {
  $isBig?: boolean;
};

export const NameWrapper = styled.div<NameWrapper>`
  display: flex;
  align-items: center;
  padding: ${props => (props.$isBig ? '6px 6px' : '12px 6px')};
`;

export const Position = styled(Typ10)`
  display: block;
  width: 56px;
  text-align: center;
  color: #607d8b;
`;

export const UserPosition = styled(Typ11)`
  display: block;
  width: 56px;
  text-align: center;
  color: #263238;
`;

export const LeaderPosition = styled(Lab110)`
  width: 36px;
  margin: 0 10px;

  > i {
    color: #ffc107;
  }
`;

export const LargeAvatar = styled(Ava36)`
  margin: 0 12px 0 0;
`;

export const SmallAvatar = styled(Ava24)`
  margin: 0 12px 0 12px;
`;

export const Name = styled(Typ21)`
  line-height: 22px;
  margin-right: 16px;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Activities = styled(Lab010)`
  padding: 16px;

  > i {
    color: #90a4ae;
  }

  > span {
    color: #607d8b;
  }
`;

export const ValueWrapper = styled.div`
  padding: 16px 16px 16px 0;
  text-align: end;
`;

type IconType = {
  $iconColor?: string;
};

export const Icon = styled(Lab010)<IconType>`
  > i {
    color: ${props => props.$iconColor || '#00ab97'};
  }
`;

export const NameTableData = styled.td`
  max-width: 0;
  overflow: hidden;
`;

type PositionTableDataProps = {
  $isUser?: boolean;
};

export const PositionTableData = styled.td<PositionTableDataProps>`
  ${props =>
    props.$isUser
      ? css`
          border-left: 8px solid #0099a9;
        `
      : css`
          padding-left: 8px;
        `}
`;
